import { css } from 'styled-components';

const PADDING = {
  100: '0.125rem',
  200: '0.25rem',
  300: '0.5rem',
  400: '0.75rem',
  500: '1rem',
  600: '1.25rem',
  700: '1.5rem',
};

export const padding = (options = {}) => css`
  padding: ${PADDING[options.size || 400]};
`;

export const horizontalFlow = (options = {}) => {
  const spacing = options.spacing || '0.5rem';
  return css`
    display: flex;
    align-items: center;
    gap: ${spacing};
  `;
};

export const verticalFlow = (options = {}) => {
  const spacing = options.spacing || '0.5rem';
  return css`
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: auto;
    row-gap: ${spacing};
    align-items: start;
    align-content: start;
  `;
};
